const NON_PROD_HOST_MARKERS = ['localhost', '127.0.0.1', 'icontractdev', 'icontractqa', 'icontractstg'];

export const isNonProdHost = (hostname = window.location.hostname) =>
  NON_PROD_HOST_MARKERS.some((marker) => hostname.includes(marker));
